export default {
  subscription: {
    manage: "Manage Subscription",
    page_title: "Subscription Management",
    page_subtitle: "Manage your subscription settings and auto-renewal preferences",
    current_subscription: "Current Subscription",
    plan: "Plan",
    billing_cycle: "Billing Cycle",
    status: "Status",
    subscription_control: "Subscription Control",
    auto_renew_cancelled:
      "Auto-renewal has been cancelled and service will stop after expiration on {date}.",
    cancel_effect:
      "Cancelling your subscription will take effect after the current billing cycle ends. Your subscription will remain active until {date}.",
    restore_prompt:
      "Your subscription has been cancelled or will be cancelled after the current billing cycle ends. To continue using our services, please restore your subscription.",
    cancel_processing:
      "Your subscription cancellation request is being processed and will take effect after the current billing cycle ends.",
    restore_processing: "Your subscription restoration request is being processed.",
    expired_desc:
      "Your subscription has expired. Please update your payment information to restore service.",
    paused:
      "Your subscription is currently paused. Cancellation or restoration operations are not available.",
    trialing:
      "You are currently on a trial. The subscription will automatically convert to a paid subscription after the trial period ends.",
    no_action: "Your current subscription status does not support any operations.",
    cancel_subscription_btn: "Cancel Subscription",
    restore_subscription_btn: "Restore Subscription",
    restoring: "Restoring...",
    cancelling: "Cancelling...",
    status_unavailable: "Status Unavailable",
    no_active_subscription: "You don't have an active subscription",
    choose_plan: "Choose a Plan",
    cancel_modal_title: "Cancel Subscription",
    cancel_confirm:
      "Are you sure you want to cancel your subscription? This will take effect after the current billing cycle ends ({date}). After that, your subscription will be deactivated and you will lose access to premium features.",
    reason_label: "Reason (Optional):",
    reason_placeholder: "Please let us know why you're canceling...",
    status_updated: "Subscription status updated",
    cancel_request_submitted: "Subscription cancellation request submitted",
    cancel_failed: "Subscription cancellation failed",
    restore_request_submitted: "Subscription restoration request submitted",
    restore_failed: "Subscription restoration failed",
    active: "Active",
    canceled: "Canceled",
    cancel_pending: "Cancel Pending",
    restore_pending: "Restore Pending",
    past_due: "Past Due",
    paused_status: "Paused",
    trialing_status: "Trialing",
    next_cycle_cancel: "Next Cycle Cancel",
    unknown_status: "Unknown Status",
    monthly: "Monthly",
    yearly: "Yearly",
  },
  invoices: {
    recent: "Recent Invoices",
    number: "Invoice Number",
    order_no: "Order No",
    amount: "Amount",
    status: "Status",
    created_at: "Created At",
    actions: "Actions",
    status_issued: "Issued",
    status_paid: "Completed",
    status_voided: "Voided",
    view_all: "View All Invoices",
  },
  orders: {
    no: "Order No",
    plan_type: "Plan Type",
    duration: "Duration",
    amount: "Amount",
    status: "Status",
    paid_at: "Paid At",
    created_at: "Created At",
    actions: "Actions",
    quantity: "Quantity",
    status_pending: "Pending",
    status_paid: "Completed",
    status_failed: "Failed",
    status_refunded: "Refunded",
    refund_pending: "Refund Pending",
    refund_failed: "Refund Failed",
    cancelled: "Cancelled",
    expired: "Expired",
    days: "Days",
    cancel_confirm: "Are you sure you want to cancel this order?",
    delete_confirm: "Are you sure you want to delete this order?",
    downloading_invoice: "Downloading invoice...",
    download_failed: "Download failed",
    check_refund: "Checking refund eligibility...",
    refund_not_eligible: "Refund not eligible",
    check_refund_failed: "Failed to check refund eligibility",
    prorated_refund_title: "Prorated Refund",
    prorated_refund_content: "This refund will be prorated based on your usage.",
    credits_refund_content: "This refund will be prorated based on remaining credits.",
    full_refund_title: "Full Refund",
    full_refund_content: "You are eligible for a full refund.",
    request_refund: "Request Refund",
    processing_refund: "Processing refund request...",
    refund_request_failed: "Failed to request refund",
    refund_reason: "Refund Reason",
    refund_reason_placeholder: "Please provide a reason for the refund...",
    refund_reason_required: "Refund reason is required",
    refund_conditions: "Refund Conditions",
    no_report_generated: "No Report Generated",
    no_calculations_performed: "No Calculations Performed",
    no_api_used: "No API Used",
    subscription_period: "Subscription Period",
    subscription_details: "Subscription Details",
    total_days: "Total Days",
    remaining_days: "Remaining Days",
    refund_amount: "Refund Amount",
    refund_reasons: {
      order_not_found: "Order not found",
      unauthorized: "You are not authorized to refund this order",
      order_not_completed: "Only completed orders can be refunded",
      subscription_not_found: "Subscription not found",
      paid_features_used: "Paid features have been used",
      not_eligible: "Not eligible for refund",
      internal_error: "Internal error occurred while checking refund eligibility",
    },
    report_not_viewed_completely: "Report has not been viewed completely",
    no_credits_used: "No credits used",
    refund_requested: "Refund request submitted successfully",
    refund_pending_approval:
      "Refund request submitted. Refund is pending approval and may take some time to process.",
    refund_approved: "Refund approved successfully",
    refund_rejected: "Refund request was rejected",
    refund_success: "Refund Success",
    refund_processing: "Refund Processing",
    refund_success_message:
      "We have successfully processed your refund. It can take up to 5 days for funds to appear on your statement.",
    refund_processing_message: "Your refund is still being processed, please wait patiently.",
    checking_order_status: "Checking order status...",
  },
};
